import React from "react";
import { TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useFormContext } from "react-hook-form";
import { Button, Popin, Text } from "$components";
import CField from "$forms/CField";
import ContactSelect from "$forms/ContactSelect";
import { useProjectForm } from "../context/ProjectFormContext";
import { useStyles } from "../styles";
import UserForm from "../../../Coordinators/UserForm";
import useAuth from "$hooks/useAuth";

export const ProjectFormContact: React.FC = () => {
  const classes = useStyles();
  const { isAdmin } = useAuth();
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const {
    currentCompany,
    currentContact,
    isAlias,
    currentContactObject,
    openUser,
    errorUser,
    toggleUserPopin,
    handleUserAddClick,
    handleUserPopinSubmit,
  } = useProjectForm();

  return (
    <>
      <div className="jFormSectionHead">
        <Text type="h3">Informations contact</Text>
      </div>
      {isAdmin && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 16,
          }}
        >
          <Button
            onClick={handleUserAddClick}
            style={{ textTransform: "none" }}
            disabled={!currentCompany}
            color="secondary"
          >
            <AddIcon />
            Ajouter un utilisateur
          </Button>
        </div>
      )}
      <CField control={control} name="contact" error={errors.contact}>
        {(props) => <ContactSelect {...props} companyId={currentCompany} />}
      </CField>
      <div className={classes.newFormFieldsRow}>
        <div className={classes.newFormFieldsCol}>
          <TextField
            value={
              currentContactObject?.email && !isAlias
                ? currentContactObject?.email
                : ""
            }
            disabled
            label="Email"
            variant="outlined"
            style={{ width: "100%" }}
          />
        </div>
        <div className={classes.newFormFieldsCol}>
          <TextField
            value={
              currentContactObject?.phone && !isAlias
                ? currentContactObject?.phone
                : ""
            }
            disabled
            label="Téléphone"
            variant="outlined"
            style={{ width: "100%" }}
          />
        </div>
      </div>

      <Popin openPopin={openUser} toggleDrawer={toggleUserPopin}>
        <Text type="h2">
          {currentContact ? "Modifier le contact" : "Ajouter un contact"}
        </Text>
        <UserForm
          user={currentContact}
          onSubmit={handleUserPopinSubmit}
          onReset={() => toggleUserPopin(false)}
          error={errorUser}
          isCoordinator={false}
          canBeUser
        />
      </Popin>
    </>
  );
};
